/// <amd-module name="VSSUI/Registration/SpinnerComponentRegistration" />
import * as React from "react";
import { VssComponent } from "VSS/Platform/Layout";
import { Spinner } from "../Spinner";

class SpinnerComponent extends React.Component {
    public render(): JSX.Element {
        return <Spinner {...this.props} />;
    }
}

VssComponent.register("spinner", SpinnerComponent);
